
export class SnmpConstants {

    // InetAddressType
    public static InetAddressType_unknown = 0;
    public static InetAddressType_ipv4 = 1;
    public static InetAddressType_ipv6 = 2;
    public static InetAddressType_ipv4z = 3;
    public static InetAddressType_ipv6z = 4;
    public static InetAddressType_dns = 16;

    // ipAddressType
    public static ipAddressType_unicast = 1;
    public static ipAddressType_anycast = 2;
    public static ipAddressType_broadcast = 3;

    public static IpAddressTypeToString(ipAddrType: number): string {
        var typeStr = "unknown";

        switch (ipAddrType) {
            case SnmpConstants.ipAddressType_unicast: typeStr = "unicast"; break;
            case SnmpConstants.ipAddressType_anycast: typeStr = "anycast"; break;
            case SnmpConstants.ipAddressType_broadcast: typeStr = "broadcast"; break;
        }

        return (typeStr);
    }

    // ipAddressOrigin
    public static ipAddressOrigin_unknown = 0;
    public static ipAddressOrigin_other = 1;
    public static ipAddressOrigin_manual = 2;
    public static ipAddressOrigin_dhcp = 4;
    public static ipAddressOrigin_linklayer = 5;
    public static ipAddressOrigin_random = 6;

    public static IpAddressOriginToString(ipOrigin: number): string {
        var originStr = "unknown";

        switch (ipOrigin) {
            case SnmpConstants.ipAddressOrigin_unknown: originStr = "unknown"; break;
            case SnmpConstants.ipAddressOrigin_other: originStr = "other"; break;
            case SnmpConstants.ipAddressOrigin_manual: originStr = "manual"; break;
            case SnmpConstants.ipAddressOrigin_dhcp: originStr = "dhcp"; break;
            case SnmpConstants.ipAddressOrigin_linklayer: originStr = "linklayer"; break;
            case SnmpConstants.ipAddressOrigin_random: originStr = "random"; break;
        }

        return (originStr);
    }

    public static IpAddressOriginFromString(ipOrigin: string): number {
        var origin = SnmpConstants.ipAddressOrigin_unknown;

        switch (ipOrigin) {
            case "unknown": origin = SnmpConstants.ipAddressOrigin_unknown; break;
            case "other": origin = SnmpConstants.ipAddressOrigin_other; break;
            case "manual": origin = SnmpConstants.ipAddressOrigin_manual; break;
            case "dhcp": origin = SnmpConstants.ipAddressOrigin_dhcp; break;
            case "linklayer": origin = SnmpConstants.ipAddressOrigin_linklayer; break;
            case "random": origin = SnmpConstants.ipAddressOrigin_random; break;
        }

        return (origin);
    }

    // ipAddressStatus
    public static ipAddressStatus_preferred = 1;
    public static ipAddressStatus_deprecated = 2;
    public static ipAddressStatus_invalid = 3;
    public static ipAddressStatus_inaccessible = 4;
    public static ipAddressStatus_unknown = 5;
    public static ipAddressStatus_tentative = 6;
    public static ipAddressStatus_duplicate = 7;
    public static ipAddressStatus_optimistic = 8;

    public static IpAddressStatusToString(ipStatus: number): string {
        var statusStr = "unknown";

        switch (ipStatus) {
            case SnmpConstants.ipAddressStatus_preferred: statusStr = "preferred"; break;
            case SnmpConstants.ipAddressStatus_deprecated: statusStr = "deprecated"; break;
            case SnmpConstants.ipAddressStatus_invalid: statusStr = "invalid"; break;
            case SnmpConstants.ipAddressStatus_inaccessible: statusStr = "inaccessible"; break;
            case SnmpConstants.ipAddressStatus_unknown: statusStr = "unknown"; break;
            case SnmpConstants.ipAddressStatus_tentative: statusStr = "tentative"; break;
            case SnmpConstants.ipAddressStatus_duplicate: statusStr = "duplicate"; break;
            case SnmpConstants.ipAddressStatus_optimistic: statusStr = "optimistic"; break;
        }

        return (statusStr);
    }

    public static IpAddressStatusFromString(ipStatus: string): number {
        var status = SnmpConstants.ipAddressStatus_unknown;

        switch (ipStatus) {
            case "preferred": status = SnmpConstants.ipAddressStatus_preferred; break;
            case "deprecated": status = SnmpConstants.ipAddressStatus_deprecated; break;
            case "invalid": status = SnmpConstants.ipAddressStatus_invalid; break;
            case "inaccessible": status = SnmpConstants.ipAddressStatus_inaccessible; break;
            case "unknown": status = SnmpConstants.ipAddressStatus_unknown; break;
            case "tentative": status = SnmpConstants.ipAddressStatus_tentative; break;
            case "duplicate": status = SnmpConstants.ipAddressStatus_duplicate; break;
            case "optimistic": status = SnmpConstants.ipAddressStatus_optimistic; break;
        }

        return (status);
    }

    // TruthValue
    public static TruthValue_true = 1;
    public static TruthValue_false = 2;

    // RowStatus
    public static RowStatus_active = 1;
    public static RowStatus_notInService = 2;
    public static RowStatus_notReady = 3;
    public static RowStatus_createAndGo = 4;
    public static RowStatus_createAndWait = 5;
    public static RowStatus_destroy = 6;

    // ifType

    // WELL KNOWN ifTypes
    public static ifType_other = 1;
    public static ifType_ethernetCsmacd = 6;
    public static ifType_propPointToPointSerial = 22;
    public static ifType_ppp = 23;
    public static ifType_softwareLoopback = 24;
    public static ifType_slip = 28;
    public static ifType_frameRelay = 32;
    public static ifType_rs232 = 33;
    public static ifType_propVirtual = 53;
    public static ifType_fastEther = 62;
    public static ifType_gigabitEthernet = 117;
    public static ifType_tunnel = 131;
    public static ifType_l2vlan = 135;
    public static ifType_l3ipvlan = 136;
    public static ifType_l3ipxvlan = 137;
    public static ifType_ieee8023adLag = 161;

    public static ifType_pppMultilinkBundle = 108;

    public static ifType_bridge = 209; //  -- Transparent bridge interface

    // Legacy ethernet types
    public static ifType_iso88023Csmacd = 7;
    public static ifType_starLan = 11;
    //public static ifType_fastEther = 62;
    public static ifType_fastEtherFX = 69;
    //public static ifType_gigabitEthernet = 117;

    // WIRELESS ifTypes
    public static ifType_ieee80211 = 71;
    public static ifType_propWirelessP2P = 157;
    public static ifType_propDocsWirelessMaclayer = 180;
    public static ifType_propDocsWirelessDownstream = 181;
    public static ifType_propDocsWirelessUpstream = 182;
    public static ifType_hiperlan2 = 183;
    public static ifType_propBWAp2Mp = 184;

    // ifStatus
    public static ifStatus_up = 1;
    public static ifStatus_down = 2;
    public static ifStatus_testing = 3;
    public static ifStatus_unknown = 4;
    public static ifStatus_dormant = 5;
    public static ifStatus_notPresent = 6;
    public static ifStatus_lowerLayerDown = 7;

    public static IfStatusToString(ifStatus: number): string {
        var statusStr = "unknown";

        switch (ifStatus) {
            case SnmpConstants.ifStatus_up: statusStr = "up"; break;
            case SnmpConstants.ifStatus_down: statusStr = "down"; break;
            case SnmpConstants.ifStatus_testing: statusStr = "testing"; break;
            case SnmpConstants.ifStatus_unknown: statusStr = "unknown"; break;
            case SnmpConstants.ifStatus_dormant: statusStr = "dormant"; break;
            case SnmpConstants.ifStatus_notPresent: statusStr = "notPresent"; break;
            case SnmpConstants.ifStatus_lowerLayerDown: statusStr = "lowerLayerDown"; break;
        }

        return (statusStr);
    }

    // POWER-ETHERNET-MIB CONSTANTS
    public static pethPsePortAdminEnable_unknown = 0;
    public static pethPsePortAdminEnable_true = 1;
    public static pethPsePortAdminEnable_false = 2;

    public static PsePortAdminEnableToString(adminEnable: number): string {
        let statusStr = "unknown";

        switch (adminEnable) {
            case SnmpConstants.pethPsePortAdminEnable_true:
                statusStr = "true";
                break;
            case SnmpConstants.pethPsePortAdminEnable_false:
                statusStr = "false";
                break;
            default:
                statusStr = "";
                break;
        }

        return (statusStr);
    }

    public static pethPsePortDetectionStatus_disabled = 1;
    public static pethPsePortDetectionStatus_searching = 2;
    public static pethPsePortDetectionStatus_deliveringPower = 3;
    public static pethPsePortDetectionStatus_fault = 4;
    public static pethPsePortDetectionStatus_test = 5;
    public static pethPsePortDetectionStatus_otherFault = 6;

    public static PsePortDetectionStatusToString(detectionStatus: number): string {
        let statusStr = "";

        switch (detectionStatus) {
            case SnmpConstants.pethPsePortDetectionStatus_disabled:
                statusStr = "Disabled";
                break;
            case SnmpConstants.pethPsePortDetectionStatus_searching:
                statusStr = "Searching";
                break;
            case SnmpConstants.pethPsePortDetectionStatus_deliveringPower:
                statusStr = "Delivering Power";
                break;
            case SnmpConstants.pethPsePortDetectionStatus_fault:
                statusStr = "Fault";
                break;
            case SnmpConstants.pethPsePortDetectionStatus_test:
                statusStr = "Test"; break;
            case SnmpConstants.pethPsePortDetectionStatus_otherFault:
                statusStr = "Other Fault"; break;
            default:
                statusStr = "";
                break;
        }

        return (statusStr);
    }

    // Entity MIB CONSTANTS
    public static entPhysicalClass_other = 1;
    public static entPhysicalClass_unknown = 2;
    public static entPhysicalClass_chassis = 3;
    public static entPhysicalClass_backplane = 4;
    public static entPhysicalClass_container = 5;
    public static entPhysicalClass_powerSupply = 6;
    public static entPhysicalClass_fan = 7;
    public static entPhysicalClass_sensor = 8;
    public static entPhysicalClass_module = 9;
    public static entPhysicalClass_port = 10;
    public static entPhysicalClass_stack = 11;

    // hrStorageType CONSTANTS
    public static hrStorageType_hrStorageOther = 1;
    public static hrStorageType_hrStorageRam = 2; // The storage type identifier used for RAM.
    public static hrStorageType_hrStorageVirtualMemory = 3; // The storage type identifier used for virtual memory, temporary storage of swapped or paged memory.
    public static hrStorageType_hrStorageFixedDisk = 4; // The storage type identifier used for non-removable rigid rotating magnetic storage devices.
    public static hrStorageType_hrStorageRemovableDisk = 5; // The storage type identifier used for removable rigid rotating magnetic storage devices.
    public static hrStorageType_hrStorageFloppyDisk = 6; // The storage type identifier used for non-rigid rotating magnetic storage devices.
    public static hrStorageType_hrStorageCompactDisc = 7; // The storage type identifier used for read-only rotating optical storage devices.
    public static hrStorageType_hrStorageRamDisk = 8; // The storage type identifier used for a file system that is stored in RAM.
    public static hrStorageType_hrStorageFlashMemory = 9; // The storage type identifier used for flash memory.
    public static hrStorageType_hrStorageNetworkDisk = 10; // The storage type identifier used for a networked file system.

}
